import { render } from "./dimension.html?vue&type=template&id=76a520ad"
import script from "./Dimension.vue?vue&type=script&lang=ts"
export * from "./Dimension.vue?vue&type=script&lang=ts"

import "./dimension.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script